import TaxInfo from './TaxInfo'

export default TaxInfo
